module.exports = __webpack_public_path__ + "img/temp_created_mind.ca36fac4.svg";